import React from "react";
import { compose, defaultProps, toClass } from "recompose";
import { Select } from "antd";
import styled from "styled-components/macro";
import * as R from "ramda";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const StatusSelect = ({
  value,
  options,
  onChange,
  disabled,
  valueProp,
  statusProp,
  optionsSchema,
  valuePlaceholder,
  statusPlaceholder
}) => {
  return (
    <Container>
      <Select
        showSearch
        filterOption
        disabled={disabled}
        style={{ marginRight: 8 }}
        optionFilterProp="children"
        placeholder={valuePlaceholder}
        value={value[valueProp]}
        onChange={newValue => onChange(R.assoc(valueProp, newValue, value))}
      >
        {options.values.map((option, index) => (
          <Select.Option key={index} value={option[optionsSchema.value]}>
            {option[optionsSchema.label]}
          </Select.Option>
        ))}
      </Select>
      <Select
        showSearch
        filterOption
        disabled={disabled}
        optionFilterProp="children"
        placeholder={statusPlaceholder}
        value={value[statusProp]}
        onChange={newStatus => onChange(R.assoc(statusProp, newStatus, value))}
      >
        {options.statuses.map((status, index) => (
          <Select.Option key={index} value={status[optionsSchema.value]}>
            {status[optionsSchema.label]}
          </Select.Option>
        ))}
      </Select>
    </Container>
  );
};

export default compose(
  toClass,
  defaultProps({
    value: {},
    options: {},
    valuePlaceholder: "",
    statusPlaceholder: "",
    valueProp: "value",
    statusProp: "status",
    optionsSchema: {
      value: "value",
      label: "label"
    }
  })
)(StatusSelect);
